export const TTS_STORAGE_BUCKET = "audio files";

export function ttsStoragePrefix(taskId: number): string {
    return `tts/${taskId}`;
}

/**
 * The storage path is derived from the task id and segment index alone —
 * never stored in the DB/content JSON — so generating audio never requires
 * touching a task's content.
 */
export function ttsAudioStoragePath(taskId: number, segmentIndex: number): string {
    return `${ttsStoragePrefix(taskId)}/${segmentIndex}.mp3`;
}
